import { motion } from "framer-motion";
import { Trophy, CupSoda, Wifi, Headphones } from "lucide-react";

const PERKS = [
  { icon: CupSoda, title: "Free Water & Soft Drinks", sub: "On every booking" },
  { icon: Wifi, title: "Fast WiFi", sub: "Stream, upload, share" },
  { icon: Headphones, title: "Sennheiser HD 25s", sub: "Free to use, every session" },
];

export const DjRoomPerks = ({ className = "", testId = "dj-room-perks", stacked = false }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5 }}
    className={`relative overflow-hidden rounded-3xl border border-cyan-500/30 bg-gradient-to-br from-cyan-500/10 via-dream-surface/60 to-dream-violet/10 p-6 md:p-8 ${className}`}
    data-testid={testId}
  >
    <div className={`flex flex-col gap-6 ${stacked ? "" : "lg:flex-row lg:items-center lg:gap-10"}`}>
      <div className={stacked ? "" : "lg:w-2/5"}>
        <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-400 text-black text-xs font-bold uppercase tracking-wide">
          <Trophy className="w-3.5 h-3.5" /> Cheapest in Melbourne
        </span>
        <h3 className="font-heading text-2xl md:text-3xl font-bold text-white mt-3 leading-tight">
          Melbourne&apos;s cheapest pro DJ room.
        </h3>
        <p className="text-white/60 text-sm mt-2">Included free with every DJ Room service. No extras, no hidden fees.</p>
      </div>
      <div className={`grid sm:grid-cols-3 gap-3 ${stacked ? "" : "lg:flex-1"}`}>
        {PERKS.map(({ icon: Icon, title, sub }) => (
          <div key={title} className="flex items-start gap-3 p-4 rounded-2xl bg-white/[0.04] border border-white/10">
            <div className="w-10 h-10 rounded-xl bg-cyan-500/15 flex items-center justify-center flex-shrink-0">
              <Icon className="w-5 h-5 text-cyan-300" />
            </div>
            <div>
              <p className="text-white font-semibold text-sm">{title}</p>
              <p className="text-white/50 text-xs">{sub}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </motion.div>
);
